// extracted by mini-css-extract-plugin
export default {"categories":"Categories_categories__XjQzc","active":"Categories_active__LDhFR"};